import { type EmailTemplate, type EmailTemplatePurpose } from '../../../models/Scheduling'
import { useGetSchedulingEmailTemplatesQuery } from '../../../store/scheduling/scheduling'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'

export const useSchedulingEmailTemplates = () => {
  const accountId = useAppSelector(selectSafeAuthenticatedUser).accountId
  const { data: templates = [], isLoading, isError } = useGetSchedulingEmailTemplatesQuery({ accountId })
  const byPurpose = (purpose: EmailTemplatePurpose): EmailTemplate | undefined => templates.find((template) => template.purpose === purpose)
  return { templates, isLoading, isError, byPurpose }
}
